import { Link } from "react-router-dom";

/** Home pillar #1 — promote the automated design engine (the headline capability)
 *  to a named section linking to its deep page. */
export function DesignEngineBand() {
  return (
    <section className="landing-band" id="design-engine">
      <div className="landing-wrap landing-section">
        <div className="de-band">
          <div className="de-copy">
            <h2 className="section-title" style={{ textAlign: "left" }}>
              A floor plan goes in. A complete structural design comes out.
            </h2>
            <p className="section-sub" style={{ margin: "0 0 18px", textAlign: "left" }}>
              The engine builds the framing, sizes every member, routes the load path, and flags the
              governing case, all within the standards you set. Every run hands back a stamp-ready
              plan set and a calc-report package. Deterministic and code-traceable; a licensed PE
              reviews and stamps. AI never does.
            </p>
            <div className="de-chips">
              {["Framing systems", "Members & beams", "Lateral system", "Connections"].map((c) => (
                <span className="de-chip" key={c}>{c}</span>
              ))}
            </div>
            <Link to="/platform/design-engine" className="text-link de-link">Explore the design engine →</Link>
          </div>

          <div className="de-visual">
            <div className="de-visual-head"><span>Floor framing → designed</span><span className="sample-pill">Sample</span></div>
            <svg viewBox="0 0 280 170" className="de-framing" aria-hidden="true">
              <rect x="16" y="14" width="248" height="120" fill="none" stroke="var(--color-mark)" strokeWidth="1.3" />
              {[40, 64, 88, 112, 136, 160, 184, 208, 232].map((x) => (
                <line key={x} x1={x} y1="20" x2={x} y2="128" stroke="var(--fm-spruce)" strokeWidth="0.8" opacity="0.5" />
              ))}
              <line x1="20" y1="74" x2="260" y2="74" stroke="var(--fm-spruce)" strokeWidth="2.6" />
              <rect x="23" y="71" width="6" height="6" fill="var(--fm-spruce)" />
              <rect x="137" y="71" width="6" height="6" fill="var(--fm-spruce)" />
              <rect x="251" y="71" width="6" height="6" fill="var(--fm-spruce)" />
              {/* framed stair opening — joists trimmed, doubled headers */}
              <rect x="178" y="88" width="52" height="34" fill="color-mix(in srgb, var(--fm-spruce) 2%, var(--color-surface))" stroke="var(--fm-spruce)" strokeWidth="1.3" />
              <line x1="178" y1="88" x2="230" y2="88" stroke="var(--fm-spruce)" strokeWidth="1.8" />
              <line x1="178" y1="122" x2="230" y2="122" stroke="var(--fm-spruce)" strokeWidth="1.8" />
              <text x="184" y="109" className="design-tag">STAIR</text>
              <text x="24" y="68" className="design-tag">FB-1 · 5-1/4×14 24F GLB</text>
              <text x="24" y="150" className="design-tag">JOISTS 2×10 @ 16&quot; o.c. · DF-L #2</text>
            </svg>
            <div className="de-readout">
              <div className="de-readout-row"><span className="shot-mono">FB-1 · 5-1/4×14 24F GLB</span><span className="shot-dcr">DCR 0.89 ✓</span></div>
              <div className="de-readout-row"><span className="shot-mono">Joists · 2×10 DF-L #2</span><span className="shot-dcr">DCR 0.78 ✓</span></div>
              <div className="de-readout-foot"><span className="shot-mono">Governing: bending · NDS 2024 · 14 members checked</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const POSTURE = ["Tenant-isolated", "Encrypted in transit & at rest", "Role-scoped access", "Full audit trail"];

/** Home pillar #4 — a short data-security trust band linking to /security. */
export function SecurityBand() {
  return (
    <section className="landing-wrap landing-section" id="security-band">
      <div className="sec-band">
        <div className="sec-band-copy">
          <span className="section-eyebrow">Security &amp; data trust</span>
          <h2 className="section-title" style={{ textAlign: "left" }}>Your proprietary plans never leave your control.</h2>
          <p className="section-sub" style={{ margin: 0, textAlign: "left" }}>
            Plans, standards, and material lists are tenant-fenced per firm, encrypted, access-scoped by
            role, and logged end to end. Your data works for you, and only you.
          </p>
        </div>
        <div className="sec-band-side">
          <ul className="sec-chips">
            {POSTURE.map((p) => <li key={p}>{p}</li>)}
          </ul>
          <Link to="/security" className="text-link">How we protect your data →</Link>
        </div>
      </div>
    </section>
  );
}
